import {Component} from 'react';
import injectSheet from 'react-jss';
import {connect} from 'react-redux';

import NavigationService from '-/services/NavigationService';
import {isMobile} from '-/util/util';
import {ControlGroup} from '-/components/fields/Control';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import Button from '-/components/general/Button';
import Form from '-/components/fields/Form';
import Legend from '-/components/fields/Legend';
import {get} from '-/util/lodash';
import BuyerInfoService from '-/services/BuyerInfoService';

const styles = () => ({
    warning: {
        backgroundColor: 'white',
        border: '2px solid red',
        fontWeight: 'bold',
        marginBottom: 15,
        padding: 10,
        textAlign: 'center'
    }
});

class FinalQuestions extends Component {
    constructor(props) {
        super(props);

        this.handleGoClick = this.handleGoClick.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    handleRadioChange(e) {
        const {value: answer} = e.target;
        const hasCoApp = ['YES', 'YESPREVIOUSCOAPP'].includes(answer);

        NavigationService.set('buyerHasCoApp', answer);
        NavigationService.set('coAppUnlocked', hasCoApp);

        if (!hasCoApp) {
            BuyerInfoService.clearCoApplicant();
        }
    }

    handleGoClick() {
        const {buyerHasCoApp} = this.props;
        const hasCoApp = ['YES', 'YESPREVIOUSCOAPP'].includes(buyerHasCoApp);

        NavigationService.next(hasCoApp ? 'addCoApp' : 'finalReview');
    }

    renderOptions() {
        const {buyerHasCoApp, coApplicantName, isDealer, readOnly} = this.props;
        const question = {
            label: isDealer ? 'Do you wish to add a Co-Applicant?' : 'Is there a Co-Applicant on your title?',
            key: 'isThereACoApp',
            options: [{
                value: 'YES',
                label: 'Yes',
                checked: buyerHasCoApp === 'YES'
            }, {
                value: 'NO',
                label: 'No',
                checked: buyerHasCoApp === 'NO'
            }, {
                value: 'UNSURE',
                label: 'Unsure',
                checked: buyerHasCoApp === 'UNSURE'
            }]
        };

        if (coApplicantName) {
            question.options.unshift({
                value: 'YESPREVIOUSCOAPP',
                label: `Yes (${coApplicantName})`,
                checked: buyerHasCoApp === 'YESPREVIOUSCOAPP'
            });
        }

        return (
            <ControlGroup>
                <Legend>{question.label}</Legend>
                <RadioGroup vertical={isMobile()}>
                    {question.options.map(option => {
                        const id = question.key + '_' + option.value;
                        return (
                            <Radio
                                disabled={readOnly}
                                key={id}
                                id={id}
                                label={option.label}
                                onChange={this.handleRadioChange}
                                name={question.key}
                                value={option.value}
                                checked={!!option.checked} />
                        );
                    })}
                </RadioGroup>
            </ControlGroup>
        );
    }

    render() {
        const {classes = {}, requireCoBuyerSameAddress} = this.props;

        return (
            <div>
                <Form standalone={true}>
                    <div>
                        {this.renderOptions()}
                        {requireCoBuyerSameAddress && (
                            <p className={classes.warning}>
                                The co-applicant must live at the same address as you
                            </p>
                        )}
                        <Button btnStyle="alternate" onClick={this.handleGoClick}>Go</Button>
                    </div>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = props => {
    const {creditor} = props;
    const {requireCoBuyerSameAddress, type} = creditor;
    const coApplicantName = get(props, 'buyerInfo.buyerInfo_CoApp.name');

    return {
        isCU: type === 'creditUnion',
        isDealer: type === 'dealer',
        requireCoBuyerSameAddress,
        coApplicantName,
        ...NavigationService.getReducerState()
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(FinalQuestions));
